import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { NaoEncontrei, INaoEncontrei } from '../../../../models/naoEncontrei.model';
import { UsersService } from '../../../../models/usuarios.service';
import { Subscription } from 'rxjs';
import { DadosService } from '../../db/dados.service';
import { Router } from '@angular/router';

@Component({
    selector: 'sugestoes',
    templateUrl: './sugestoes.html',
    styles: ['./sugestoes.scss']
})

export class SugestoesComponent implements OnInit, OnDestroy {
    @Input()
    title:string = "Sugestão de Produto"
    fFornecedor:number = -1;
    @Input()
    get fornecedor(){
       return this.fFornecedor; 
    };
    set fornecedor(x){
        if (x!=this.fFornecedor) {
          this.fFornecedor = x;
          this.reload();
        }
    }
    dadosEvent: Subscription;
    items: any[] = [];
    
    constructor(private db: AngularFirestore,
        private users: UsersService,
        private dados:DadosService,
        private router: Router) {

       
        this.dadosEvent = this.dados.listaNaoEncontradosClass.changedEvent.subscribe(
            d => { 
                //console.log(d);
                this.items = d;
                 }
        )
        this.fornecedor = users.usuario.fornecedor;
        //console.log(this.fornecedor);
        //this.reload();
    }

    abrir(){
      this.router.navigate(['/listaNaoEncontrados',this.fornecedor]);
    }
  


    reload(){
       // console.log('reload');
       //if (this.fFornecedor)   
          this.dados.listaNaoEncontradosClass.fornecedor = this.fFornecedor;
   }

    ngOnInit(): void { }
   ngOnDestroy(){
       this.dadosEvent.unsubscribe();
   }

}
